import { render, staticRenderFns } from "./SignatureInput.vue?vue&type=template&id=2808df5e&"
import script from "./SignatureInput.vue?vue&type=script&lang=js&"
export * from "./SignatureInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports